import { createMatchSelector, RouterRootState } from "connected-react-router";

function teamDetailIdSelector(state: sage.state.IRedux): string | null {
    const matchSelector = createMatchSelector<
        RouterRootState,
        { teamId: string }
    >("/home/teams/team/:teamId");
    const match = matchSelector(state);
    if (match?.params.teamId) {
        return match.params.teamId;
    } else {
        return null;
    }
}

export default teamDetailIdSelector;
